import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { VERTICALS } from "@/lib/site";
import { Overline, FadeUp } from "./Motion";

export const Verticals = () => {
  return (
    <section id="verticals" className="bg-white py-24 lg:py-36">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-8 mb-16">
          <div>
            <Overline>What we do</Overline>
            <FadeUp>
              <h2 className="mt-5 font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight text-royal-deep leading-none max-w-xl">
                Three surfaces. <span className="italic text-royal">One obsession.</span>
              </h2>
            </FadeUp>
          </div>
          <FadeUp delay={0.15}>
            <p className="max-w-sm text-muted-foreground lg:text-lg">
              Every project is a canvas of surfaces. We master the three that define a space —
              underfoot, overhead, and on the skin of the building.
            </p>
          </FadeUp>
        </div>

        <div className="grid lg:grid-cols-3 gap-6 lg:gap-8">
          {VERTICALS.map((v, i) => (
            <motion.article
              key={v.title}
              data-testid={`vertical-${v.title.toLowerCase()}`}
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1], delay: i * 0.12 }}
              className="group relative overflow-hidden rounded-lg bg-bone cursor-default"
            >
              <div className="relative h-[440px] lg:h-[560px] overflow-hidden">
                <img
                  src={v.image}
                  alt={`${v.title} solutions — premium ${v.title.toLowerCase()} by Fascinated by Floors`}
                  className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-royal-deep/80 via-royal-deep/10 to-transparent" />
                <span className="absolute top-6 left-6 font-display text-white/70 text-xl">{v.no}</span>
                <div className="absolute bottom-0 inset-x-0 p-7 text-white">
                  <div className="flex items-center justify-between">
                    <h3 className="font-display text-3xl lg:text-4xl tracking-tight">{v.title}</h3>
                    <ArrowUpRight className="h-6 w-6 opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-500" />
                  </div>
                  <p className="mt-3 text-sm text-white/80 leading-relaxed max-w-sm">{v.desc}</p>
                </div>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};
